<div class="side-bar section-padding pb-0">
  <div class="advertisement-slider swiper-container h-auto mb-xl-20" *ngIf="featuredStores.length; else noFeatured">
    <div class="swiper-wrapper">
      <div class="swiper-slide" *ngFor="let post of featuredStores">
        <div class="testimonial-wrapper">
          <div class="testimonial-box">
            <div class="testimonial-img p-relative">
              <a [routerLink]="['/blog-details', post.id]">
                <img
                  [src]="getStoreImage(post)"
                  class="img-fluid full-width"
                  [alt]="getStore(post.storeId)?.storeName || post.storeName"
                  onerror="this.src='assets/img/blog/438x180/shop-1.jpg'"
                />
              </a>
              <div class="overlay">
                <div class="brand-logo">
                  <img
                    [src]="getStoreLogo(post)"
                    class="img-fluid"
                    [alt]="getStore(post.storeId)?.storeName || post.userInfo?.name || 'Store'"
                    onerror="this.src='assets/img/user/user-1.png'"
                  />
                </div>
                <div class="add-fav text-light-white"><img src="assets/img/svg/013-heart-1.svg" alt="tag" /></div>
              </div>
            </div>
            <div class="testimonial-caption padding-15">
              <p class="text-light-white text-uppercase no-margin fs-12">Featured store</p>
              <h5 class="fw-600">
                <a [routerLink]="['/blog-details', post.id]" class="text-light-black">
                  {{ getStore(post.storeId)?.storeName || post.storeName }}
                </a>
              </h5>
              <div class="testimonial-user-box">
                <img
                  [src]="getStoreLogo(post)"
                  class="rounded-circle"
                  [alt]="getStore(post.storeId)?.storeName || post.userInfo?.name || 'Store'"
                  style="width: 36px; height: 36px; object-fit: cover"
                />
                <div class="testimonial-user-name">
                  <p class="text-light-black fw-600">
                    {{ getStore(post.storeId)?.storeName || post.storeName }}
                  </p>
                  <span class="text-light-black">
                    {{ post.topics?.join(', ') || 'General' }}
                  </span>
                </div>
              </div>
              <p class="text-light-black">{{ getStore(post.storeId)?.description || post.description }}</p>
              <p class="text-light-white fw-100" *ngIf="getStore(post.storeId)?.address">
                <strong class="text-light-black fw-700">Address: </strong>
                {{ getStore(post.storeId)?.address }}
              </p>
              <a [routerLink]="['/blog-details', post.id]" class="btn-second btn-submit">View Post</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>

  <ng-template #noFeatured>
    <p class="text-light-white">No featured stores available.</p>
  </ng-template>

  <div class="large-product-box mb-xl-20" *ngIf="featuredStores.length">
    <img
      [src]="getStoreImage(featuredStores[0])"
      class="img-fluid full-width"
      [alt]="getStore(featuredStores[0].storeId)?.storeName || featuredStores[0].storeName"
      onerror="this.src='assets/img/blog/446x1025/ad-1.jpg'"
    />
    <div class="category-type overlay padding-15">
      <button class="category-btn">Most popular near you</button>
      <a [routerLink]="['/blog-details', featuredStores[0]?.id]" class="btn-first white-btn text-light-black fw-600 full-width">See post</a>
    </div>
  </div>

  <div class="inner-wrapper main-box" *ngIf="featuredStores.length">
    <div class="main-banner p-relative">
      <img
        [src]="getStoreImage(featuredStores[0])"
        class="img-fluid full-width main-img"
        [alt]="getStore(featuredStores[0].storeId)?.storeName || featuredStores[0].storeName"
      />
      <div class="overlay-2 main-padding">
        <img
          [src]="getStoreLogo(featuredStores[0])"
          class="img-fluid"
          [alt]="getStore(featuredStores[0].storeId)?.storeName || featuredStores[0].storeName"
          onerror="this.src='assets/img/logo-2.jpg'"
        />
      </div>
      <img src="assets/img/banner/burger.png" class="footer-img" alt="footerimg" />
    </div>
    <div class="section-2 main-page main-padding">
      <div class="login-box">
        <h3 class="text-light-black fw-700">{{ getStore(featuredStores[0].storeId)?.storeName || featuredStores[0]?.storeName }}</h3>
        <div class="input-group row">
          <div class="col-12">
            <p class="text-light-white mb-0">{{ getStore(featuredStores[0].storeId)?.description || featuredStores[0]?.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
